<template>
    <div class="popup visible" id="human-test-popup" @click.stop="">
        <pre-loader-component :visible="loading"></pre-loader-component>
        <div v-if="!loading" class="max-w-content">
                    <p class="box-title center">Тест</p>
            <div class="completed-test-view" >
                <div class="test-results">
                    <p v-for="(result, index) in results" :key="index">
                        {{result.text}} -
                        {{result.value}} баллов
                    </p>
                </div>
                <p class="box-title">Суждения:</p>
                <questionnaire-list :list="lists[0]" :answers="answers" :view-mode="true" title="Test"
                                    class="test-box"></questionnaire-list>
                <div class="center">
                    <span @click="$emit('up-click')" title="Наверх" class="js-scroll-to-top"><span>
                        <icon-base width="16" height="16" viewBox="0 0 16 16"><icon-arrow-up/></icon-base>
                                    Наверх</span>
                    </span>
                </div>
            </div>
            <span v-show="!loading" class="js-close-popup" title="Закрыть" @click="$emit('close')">
                <icon-base width="14" height="14" viewBox="0 0 14 14" icon-name="Закрыть"><icon-close/></icon-base>
            </span>
        </div>
    </div>
</template>

<script>

    import {mapActions, mapState} from 'vuex'
    import QuestionnaireList from "../Questionnaire/QuestionnaireList";
    import PreLoaderComponent from "../common/PreLoader";
    import IconBase from "../common/IconBase";
    import IconClose from "../common/icons/IconClose";
    import IconArrowUp from "../common/icons/IconArrowUp";

    export default {
        name: 'test-view',
        components: {
            IconArrowUp,
            IconBase,
            IconClose,
            PreLoaderComponent,
            QuestionnaireList,
        },
        data() {
            return {
                loading: true
            }
        },
        computed: {
            ...mapState({
                lists: state => state.people.test,
                answers: state => state.people.testAnswers,
                results: state => state.people.testResults,
            }),
        },
        props: {
        },
        methods: {
            ...mapActions('people',[
                'getTestQuestions'
            ]),
        },
        created() {
            this.getTestQuestions().then(() => {
                this.loading = false;
            })
        }
    }
</script>

<style scoped>

</style>
